import React, { useEffect, useState, useRef, useCallback } from "react";
import MetaTags from "react-meta-tags";
import { Row, Col, Card, CardBody, Button } from "reactstrap";
import Select from "react-select";
import Breadcrumbs from "../../components/Common/Breadcrumb";
import moment from "moment";
import { useDispatch, useSelector } from "react-redux";
import { getNewCustomers } from "store/old/customer/actions";
import { getNewOperators } from "store/old/operator/actions";
import jwt from "jsonwebtoken";
import FilteredEnptReports from "./FilteredEnptReports";
import { useLazyGetEnptReportQuery } from "store/enptReport/enptReport.api";
import EnptReportDetailsTab from "./EnptReportDetailsTab";

const ViewEnptReports = () => {
  const [filters, setFilters] = useState({
    customer: "",
    operator: "",
    date: "",
    history: "gnt",
  });
  const [sizePerPage, setSizePerPage] = useState(10);
  const [loading, setLoading] = useState(false);
  
  // Selection state
  const [selectedReportId, setSelectedReportId] = useState(null);
  const [selectedReportData, setSelectedReportData] = useState(null);
  const detailsRef = useRef(null);

  // Ref to hold the FilteredEnptReports refetch function so we can call it from child actions
  const refetchListRef = useRef(null);
  const handleRefetchList = useCallback(() => {
    if (refetchListRef.current) refetchListRef.current();
  }, []);
  const handleRegisterRefetch = useCallback((fn) => {
    refetchListRef.current = fn;
  }, []);

  const dispatch = useDispatch();
  const [getEnptReport, { isFetching: isFetchingReport }] = useLazyGetEnptReportQuery();

  const handleFilterChange = (name, value) => {
    setFilters((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleSelectReport = async (report) => {
    setSelectedReportId(report.id);
    setLoading(true);
    console.log("Frontend: Triggering fetch for report ID:", report.id);
    try {
      const data = await getEnptReport(report.id).unwrap();
      console.log("Frontend: Received data from getEnptReport:", data);
      setSelectedReportData(data);
      // Scroll to details tab smoothly
      setTimeout(() => {
        if (detailsRef.current) {
          window.scrollTo({ behavior: "smooth", top: detailsRef.current.offsetTop });
        }
      }, 100);
    } catch (error) {
      console.error("Frontend: Error fetching report details:", error);
    } finally {
      setLoading(false);
      console.log("Frontend: Finished fetching report details.");
    }
  };

  // Redux data
  const customers = useSelector((state) =>
    (state.customer?.customers || []).map((c) => ({
      value: c.id,
      label: c.name,
    }))
  );

  const operators = useSelector((state) =>
    (state.operator.operators || [])
      .map((o) => ({
        value: `${o.country} ${o.operator_name}`,
        label: `${o.country} ${o.operator_name}`,
      }))
      .sort((a, b) => a.label.localeCompare(b.label))
  );

  // Decode JWT
  const decodeToken = (token) => {
    try {
      return jwt.decode(token);
    } catch (error) {
      console.error("Error decoding token:", error);
      return null;
    }
  };

  const token = localStorage.getItem("authUser");
  const decodedToken = token ? decodeToken(JSON.parse(token)) : null;
  const role = decodedToken?.role || 0;

  useEffect(() => {
    dispatch(getNewCustomers());
    dispatch(getNewOperators());
  }, [dispatch]);

  return (
    <React.Fragment>
      <MetaTags>
        <title>ENPT Reports</title>
      </MetaTags>

      <div className="page-content">
        <div className="container-fluid">
          <Breadcrumbs title="ENPT Reports" breadcrumbItem="View Enpt Reports" />

          <Row>
            <Col className="col-12">
              <Card className="bg-white">
                <CardBody>
                  {/* Table Component */}
                  <Row>
                    <Col md="12" sm="12">
                      <FilteredEnptReports
                        filters={filters}
                        onFilterChange={handleFilterChange}
                        setLoading={setLoading}
                        onPageSizeChange={setSizePerPage}
                        loading={loading}
                        customers={customers}
                        operators={operators}
                        selectedReportId={selectedReportId}
                        onSelectReport={handleSelectReport}
                        onRegisterRefetch={handleRegisterRefetch}
                      />
                    </Col>
                  </Row>
                </CardBody>
              </Card>
            </Col>
          </Row>

          <div ref={detailsRef} style={{ display: selectedReportId ? "block" : "none" }}>
            {selectedReportId && (
              <EnptReportDetailsTab
                reportData={selectedReportData}
                loading={isFetchingReport}
                setLoading={setLoading}
                refetchReport={() => handleSelectReport({ id: selectedReportId })}
                refetchList={handleRefetchList}
                customers={customers}
              />
            )}
          </div>
        </div>
      </div>
    </React.Fragment>
  );
};

export default ViewEnptReports;
